import { Context, type Effect, Layer, type Option } from "effect";
import type { EditorDocumentIdentity } from "./documents-model.ts";
import type { EditorModelFailure, EditorModelHandle } from "./model.ts";
import type { EditorLanguageFailure, EditorLanguageHover, EditorLanguageLibraries } from "./language-model.ts";
export type EditorProjectFailure = EditorModelFailure | EditorLanguageFailure;
export class EditorProjectTypes extends Context.Service<EditorProjectTypes, {
  readonly libraries: (files: Readonly<Record<string, string>>, authority: string, revision: number) => Effect.Effect<EditorLanguageLibraries, EditorProjectFailure>;
}>()("workerstation/frontend/EditorProjectTypes") {
}
export const EditorProjectTypesTest = (ports: typeof EditorProjectTypes.Service) => Layer.succeed(EditorProjectTypes, ports);
export interface EditorProject {
  readonly authority: string;
  readonly target: EditorDocumentIdentity;
  readonly synchronize: Effect.Effect<void, EditorProjectFailure>;
  readonly model: (filename: string) => Effect.Effect<EditorModelHandle | undefined, EditorProjectFailure>;
  readonly hover: (filename: string, offset: number) => Effect.Effect<Option.Option<EditorLanguageHover>, EditorProjectFailure>;
}
export class EditorProjects extends Context.Service<EditorProjects, {
  readonly use: <A, E, R>(target: EditorDocumentIdentity, body: (project: EditorProject) => Effect.Effect<A, E, R>) => Effect.Effect<A, E | EditorProjectFailure, R>;
  readonly inspect: Effect.Effect<{
    readonly keys: string[];
    readonly members: number;
    readonly leases: number;
    readonly closed: boolean;
  }>;
}>()("workerstation/frontend/EditorProjects") {
}
export const EditorProjectsTest = (ports: typeof EditorProjects.Service) => Layer.succeed(EditorProjects, ports);
